// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1j7mO","inner":"Footer_inner__25Xu0","nextIcon":"Footer_nextIcon__pEY9h","innerLeft":"Footer_innerLeft__2xDZm"};